<template>
  <div class="cancel-subscription account-settings">
    <ModalKim
      v-if="modalActive"
      @close="modalActive = false"
      :mood="canceled ? 'sad' : 'happy'"
      :position="canceled ? 'left' : ''"
      :color="canceled ? '#F67D88' : '#26C2F2'"
      :key="canceled"
    >
      <template slot="body">
        <div class="modal_body" :key="canceled" v-if="!canceled">
          <h2>{{ $t('account.cancelSubscription.title') }}</h2>
          <p>{{ $t('account.cancelSubscription.textDate').split('[DATE]')[0] }}<b>{{ $d(new Date(expiresAt), 'short') }}</b>{{ $t('account.cancelSubscription.textDate').split('[DATE]')[1] }}</p>
          <p>{{ $t('account.cancelSubscription.textFooter') }}</p>
          <p v-if="error" class="modal_error_line">{{ $t('account.cancelSubscription.errorLine') }}</p>
          <footer>
            <btn @click="modalActive = false" outlined>{{ $t('account.cancelSubscription.cancel') }}</btn>
            <btn flat @click="cancelSubscription" :loading="loading">{{ $t('account.cancelSubscription.modalCta') }}</btn>
            <!-- <btn flat @click="canceled = true" :loading="loading">Quero cancelar</btn> -->
          </footer>
        </div>
        <div class="modal_body" :key="canceled" v-else>
          <h2>{{ $t('account.cancelSubscription.success.title') }}</h2>
          <p>{{ $t('account.cancelSubscription.success.text1') }}</p>
          <p>{{ $t('account.cancelSubscription.success.text2') }}</p>
          <footer>
            <btn flat href="https://customerhappinessmovile.typeform.com/to/pStQqi">{{ $t('account.cancelSubscription.success.formCta') }}</btn>
          </footer>
        </div>
      </template>
    </ModalKim>
    <btn @click="modalActive = true" class="cancel" color="purple">{{ $t('account.cancelSubscription.cta') }}</btn>
  </div>
</template>

<script>
import { ACCOUNT_ROUTE } from '@/router/utils'
import { mapState } from 'vuex'
import sabAPI from '@/api/sab'

export default {
  name: 'CancelSubscription',
  data: () => ({
    loading: false,
    canceled: false,
    error: false,
    modalActive: false
  }),
  computed: {
    ...mapState({
      expiresAt: state => state.user.subscription.expires_at,
      subscriptionId: state => state.user.subscription.uuid,
      subscriptionStatus: state => state.user.subscription.status
    }),
    accountRoute() {
      return ACCOUNT_ROUTE
    }
  },
  methods: {
    async cancelSubscription() {
      this.loading = true

      try {
        await sabAPI.cancelSubscription(this.subscriptionId)
        this.canceled = true
      } catch (e) {
        this.error = true
      }

      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .modal_body {
    h2 {
      margin-bottom: 2rem;
    }
    b {
      white-space: nowrap;
    }
    .cancel {
      white-space: nowrap;
    }
    .modal_error_line{
      color: red;
    }
    footer {
      margin-top: 2rem;
      display: flex;
      justify-content: flex-end;
      .btn {
        margin-left: 1rem;
      }
    }
  }
</style>
